export class Log {
    constructor(public userId: number, 
                public superAdminId: number, 
                public valueType: string, 
                public valueBefore: string, 
                public valueAfter: string)
    {
    }
}